import { Button, Checkbox, Col, Form, Input, InputNumber, message, Row, Select, Grid, Divider } from "antd";
import React, { useEffect, useState } from "react";
import PhoneFormat from "../../../components/models/format/phonenumber/format_number";
import { API } from "../../../setup/setupAxios";
import { jenisPengiriman, modaTransportasi } from "../../../utils/jenisPengiriman";
import { parsePengirimanText } from "../../../utils/autoFillPengiriman";

const { Option } = Select;

const { useBreakpoint } = Grid;

const currencyList = [
    { value: "USD", label: "USD - US Dollar" },
    { value: "EUR", label: "EUR - Euro" },
    { value: "IDR", label: "IDR - Indonesian Rupiah" },
    { value: "JPY", label: "JPY - Japanese Yen" },
];

const InputBarang = (props) => {
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    const { modal, editData, viewMode, hitApi, handleSendWA, setLoadingSpin } = props;
    const [form] = Form.useForm();
    const [useAutoFill, setUseAutoFill] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isEditMode = !!editData;
    // const [useCustomerPengirim, setUseCustomerPengirim] = useState(false);
    // const [useCustomerPenerima, setUseCustomerPenerima] = useState(false);
    // const [customerList, setCustomerList] = useState([]);
    useEffect(() => {
        if (editData) {
            form.setFieldsValue({
                noResi: editData.noResi || undefined,
                namaBarang: editData.namaBarang || "",
                jumlahBarang: editData.jumlahBarang || undefined,
                namaPengirim: editData.namaPengirim || "",
                kodePengiriman: editData.kodePengiriman || "",
                alamatPengirim: editData.alamatPengirim || "",
                modaTransportasi: editData.modaTransportasi || editData.ModaTransportasi || "",
                noTeleponPengirim: editData.noTeleponPengirim || "",
                emailPengirim: editData.emailPengirim || "",
                namaPenerima: editData.namaPenerima || "",
                alamatPenerima: editData.alamatPenerima || "",
                noTeleponPenerima: editData.noTeleponPenerima || "",
                emailPenerima: editData.emailPenerima || "",
                tujuanNegara: editData.tujuanNegara || editData.TujuanNegara || "",
                tujuanKota: editData.tujuanKota || editData.TujuanKota || "",
                totalOngkir: editData.totalOngkir || undefined,
                currency: editData.currency || ""
            });
        } else {
            form.resetFields();
        }
    }, [editData, form]);
    // useEffect(() => {
    //     const fetchCustomer = async () => {
    //         try {
    //             const res = await API("/api/customer");
    //             setCustomerList(res.data.data || []);
    //         } catch (err) {
    //             message.error("Gagal mengambil data customer");
    //         }
    //     };
    //     fetchCustomer();
    // }, []);
    const handleCreate = async (values) => {
        const payload = { ...values }
        setIsSubmitting(true)
        setLoadingSpin(true)
        try {

            const res = await API.post("/api/barang", payload)

            const noResi = res.data.noResi
            console.log(noResi)

            message.success("Data berhasil disimpan")

            form.resetFields()

            // refresh table
            const dataTable = await hitApi()

            // find created record
            const selectedRecord = dataTable?.find(
                item => item.noResi === noResi
            )

            // if (selectedRecord) {
            //     await handleSendWA(selectedRecord)
            // }

            modal(false)

        } catch (error) {

            console.error(error)
            message.error("Data tidak dapat disimpan")

        } finally {

            setIsSubmitting(false)
            setLoadingSpin(false)

        }
    }

    const handleUpdate = async (values) => {
        const payload = { id: editData?.id, ...values };
        setIsSubmitting(true);
        try {
            await API.put(`/api/barang/${editData?.noResi}`, payload);
            message.success("Data berhasil diperbarui");
            hitApi();
            modal(false);
        } catch (error) {
            console.error("Gagal memperbarui data:", error);
            message.error("Data tidak dapat diperbarui");
        } finally {
            setIsSubmitting(false);
        }
    };
    // const onSelectCustomerPengirim = (value) => {
    //     const selected = customerList.find(c => c.nama === value);
    //     if (!selected) return;

    //     form.setFieldsValue({
    //         alamatPengirim: selected.alamat,
    //         noTeleponPengirim: selected.noTelepon,
    //         emailPengirim: selected.email,
    //     });
    // };

    // const onSelectCustomerPenerima = (value) => {
    //     const selected = customerList.find(c => c.nama === value);
    //     if (!selected) return;

    //     form.setFieldsValue({
    //         alamatPenerima: selected.alamat,
    //         noTeleponPenerima: selected.noTelepon,
    //         emailPenerima: selected.email,
    //     });
    // };


    const onFinish = (values) => {
        values.jumlahBarang = parseInt(values.jumlahBarang, 10);
        if (isEditMode) handleUpdate(values);
        else handleCreate(values);
    };

    return (
        <div
            style={{
                background: "#fff",
                borderRadius: 24,
                padding: isMobile ? 16 : 28,
                boxShadow:
                    "0 10px 30px rgba(0,0,0,0.06)"
            }}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                {isEditMode || viewMode ? (
                    null
                ) : (
                    <>
                        <div
                            style={{
                                padding: 16,
                                background: "#f6f8fb",
                                borderRadius: 16,
                                marginBottom: 20
                            }}
                        >
                            <Checkbox
                                checked={useAutoFill}
                                onChange={(e) => {
                                    setUseAutoFill(e.target.checked);
                                }}
                            >
                                Ambil data dari whatsApp
                            </Checkbox>
                        </div>
                        <hr />
                        <Row gutter={[16, 4]}>
                            <Col xs={24} md={24}>
                                <Form.Item label="Tempel Data Pengiriman">
                                    <Input.TextArea
                                        autoSize={{
                                            minRows: 4,
                                            maxRows: 8
                                        }}
                                        placeholder={`Example:
                                        Nama Pengirim:  Qadir Habsyi
                                        Nomor WA Pengirim: 867886

                                        Nama Penerima: INDAK
                                        Alamat: Jl. Bango 3 no 31, RT 07 RW 03 , kelurahan pondok labu , kecamatan cilandak , jakarta selatan.
                                        Kode pos: 12450

                                        No hp: +6287773243055

                                        Diteruskan ke: Yaman
                                        Tujuan di Negara: Tarim
                                        Alamat Luar Negeri: Aidid - Darulmusthofa
                                        Nama: Aman
                                        No hp: 9689977
                                        Berat paket: 2
                                        Isi paket: 2`
                                        }
                                        onBlur={(e) => {
                                            const parsedData = parsePengirimanText(e.target.value);
                                            form.setFieldsValue(parsedData);
                                        }}
                                        disabled={viewMode || !useAutoFill}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
                )}
                <Row gutter={[16, 4]}>
                    <Col xs={24} md={6}>
                        <Form.Item
                            label="Jenis Pengiriman"
                            name="kodePengiriman"
                            rules={[{ required: true, message: "Masukkan Nama Penerima" }]}
                        >
                            <Select
                                placeholder="Pilih Jenis pengiriman"
                                disabled={viewMode}
                            >
                                {jenisPengiriman.map((c) => (
                                    <Option key={c.value} value={c.value}>
                                        {c.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item
                            label="Moda Transportasi"
                            name="modaTransportasi"
                            rules={[{ required: true, message: "Masukkan Moda Transportasi" }]}
                        >
                            <Select
                                placeholder="Pilih Moda Transportasi"
                                disabled={viewMode}
                            >
                                {modaTransportasi.map((c) => (
                                    <Option key={c.value} value={c.value}>
                                        {c.label}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item
                            label="Currency / Mata Uang"
                            name="currency"
                            rules={[{ required: true, message: "Masukkan Mata Uang" }]}
                        >
                            <Select
                                placeholder="Pilih Jenis Mata Uang"
                                disabled={viewMode}
                                showSearch
                                options={currencyList}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item
                            label="Harga Ongkir"
                            name="totalOngkir"
                            rules={[{ required: true, message: "Masukkan Harga Ongkir" }]}
                        >
                            <InputNumber
                                style={{ width: "100%" }}
                                formatter={(value) =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                }
                                disabled={viewMode}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 4]}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Nama Barang/Isi Paket"
                            name="namaBarang"
                            rules={[{ required: true, message: "Masukkan Nama Barang" }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Jumlah/Berat Paket"
                            name="jumlahBarang"
                            rules={[{ required: true, message: "Masukkan Jumlah Barang" }]}
                        >
                            <Input type="number" disabled={viewMode} />
                        </Form.Item>
                    </Col>
                </Row>
                {/* <Row gutter={16}>
                <Col span={12}>
                    <Form.Item>
                        <Checkbox
                            checked={useCustomerPengirim}
                            onChange={(e) => {
                                setUseCustomerPengirim(e.target.checked);
                                form.resetFields([
                                    "namaPengirim",
                                    "alamatPengirim",
                                    "noTeleponPengirim",
                                    "emailPengirim",
                                ]);
                            }}
                        >
                            Ambil dari data customer
                        </Checkbox>
                    </Form.Item>
                    <Form.Item
                        label="Nama Pengirim"
                        name="namaPengirim"
                        rules={[{ required: true, message: "Masukkan Nama Pengirim" }]}
                    >
                        {useCustomerPengirim ? (
                            <Select
                                placeholder="Pilih Customer"
                                onChange={onSelectCustomerPengirim}
                                disabled={viewMode}
                            >
                                {customerList.map((c) => (
                                    <Option key={c.nama} value={c.nama}>
                                        {c.nama}
                                    </Option>
                                ))}
                            </Select>
                        ) : (
                            <Input disabled={viewMode} />
                        )}
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item>
                        <Checkbox
                            checked={useCustomerPenerima}
                            onChange={(e) => {
                                setUseCustomerPenerima(e.target.checked);
                                form.resetFields([
                                    "namaPenerima",
                                    "alamatPenerima",
                                    "noTeleponPenerima",
                                    "emailPenerima",
                                ]);
                            }}
                        >
                            Ambil dari data customer
                        </Checkbox>
                    </Form.Item>
                    <Form.Item
                        label="Nama Penerima"
                        name="namaPenerima"
                        rules={[{ required: true, message: "Masukkan Nama Penerima" }]}
                    >
                        {useCustomerPenerima ? (
                            <Select
                                placeholder="Pilih Customer"
                                onChange={onSelectCustomerPenerima}
                                disabled={viewMode}
                            >
                                {customerList.map((c) => (
                                    <Option key={c.nama} value={c.nama}>
                                        {c.nama}
                                    </Option>
                                ))}
                            </Select>
                        ) : (
                            <Input disabled={viewMode} />
                        )}
                    </Form.Item>
                </Col>
            </Row> */}
                <Row gutter={[16, 4]}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Nama Pengirim"
                            name="namaPengirim"
                            rules={[{ required: true, message: "Masukkan Nama Pengirim" }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Nama Penerima"
                            name="namaPenerima"
                            rules={[{ required: true, message: "Masukkan Nama Pengirim" }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[16, 4]}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Alamat Penerima"
                            name="alamatPenerima"
                            rules={[{ required: true, message: "Masukkan Alamat Penerima" }]}
                        >
                            <Input.TextArea disabled={viewMode} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item
                            label="Diteruskan ke"
                            name="tujuanNegara"
                            rules={[{ required: true, message: "Masukkan Alamat Penerima" }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                        <Form.Item
                            label="Tujuan di Negara"
                            name="tujuanKota"
                            rules={[{ required: true, message: "Masukkan Alamat Penerima" }]}
                        >
                            <Input disabled={viewMode} />
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={[16, 4]}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Nomor Telepon Pengirim"
                            name="noTeleponPengirim"
                            rules={[{ required: true, message: "Masukkan Nomor Telepon Pengirim" }]}
                        >
                            <PhoneFormat disabled={viewMode} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                        <Form.Item
                            label="Nomor Telepon Penerima"
                            name="noTeleponPenerima"
                            rules={[{ required: true, message: "Masukkan Nomor Telepon Penerima" }]}
                        >
                            <PhoneFormat disabled={viewMode} />
                        </Form.Item>
                    </Col>
                </Row>

                {/* <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Email Pengirim"
                        name="emailPengirim"
                        rules={[
                            { type: "email", message: "Format email tidak valid" },
                            { required: false }
                        ]}
                    >
                        <Input disabled={viewMode} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="Email Penerima"
                        name="emailPenerima"
                        rules={[
                            { type: "email", message: "Format email tidak valid" },
                            { required: false }
                        ]}
                    >
                        <Input disabled={viewMode} />
                    </Form.Item>
                </Col>
            </Row> */}
                {!viewMode && (
                    <div
                        style={{
                            position: isMobile ? "sticky" : "relative",
                            bottom: 0,
                            background: "#fff",
                            paddingTop: 16,
                            marginTop: 24,
                            borderTop: "1px solid #f0f0f0",
                            display: "flex",
                            gap: 12,
                            justifyContent: "flex-end"
                        }}
                    >
                        <Button
                            size="large"
                            style={{
                                flex: isMobile ? 1 : "none"
                            }}
                            onClick={() => modal(false)}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            loading={isSubmitting}
                            style={{
                                flex: isMobile ? 1 : "none",
                                borderRadius: 12
                            }}
                        >
                            {isEditMode ? "Perbarui" : "Simpan"}
                        </Button>
                    </div>
                )}
            </Form>
        </div>
    );
};

export default InputBarang;